module.exports = __webpack_public_path__ + "img/pt.4051ba5d.svg";